import styled from "styled-components";
import { ICON_COST, ICON_PROFIT, ICON_REVENUE, ICON_SALES } from "../../../utils/icons";
import { naira } from "../../../utils/data";
import { useDashboardContext } from "../../../context/dashboard_context";
import { StyledIcon } from "../../../styles";
import { useEffect } from "react";
import { th } from "../../../utils/helpers";
import MiniLoader from "../../../utils/MIniLoader";



const SaleOverview = () => {


      const {
            salesOverviewLoading, salesOverviewData, getSalesOverviewData,
      } = useDashboardContext();

      const {
            month = `Jan`, year = `1970`, data: { cost = `0`, profit = `0`, revenue = `0`, amount = `0`,

            } = {} } = salesOverviewData;

      useEffect(() => {
            getSalesOverviewData();
      }, []);

      const sales = [
            { title: 'Sales', icon: ICON_SALES, amount: th(amount), color: '#1560BD', border: 'border-end' },
            { title: 'Revenue', icon: ICON_REVENUE, amount: th(revenue), color: '#817AF3', border: 'border-end' },
            { title: 'Profit', icon: ICON_PROFIT, amount: th(profit), color: '#DBA362CC', border: 'border-0' },
            { title: 'Cost', icon: ICON_COST, amount: th(cost), color: '#58D365B2', border: 'border-start' },
      ];

      return (
            <StyledSaleOverview className="h-100">
                  <div className="main-container">
                        <div className="d-flex gap-2">

                              <h4 className="mb-4 grey-bold-text">
                                    Sales Overview
                              </h4>
                              <p className="mt-1 text-itallics green-text small">
                                    ( {month + ", " + year} )
                              </p>
                              <MiniLoader
                                    load={salesOverviewLoading}
                              />
                        </div>
                        <div className="justify-content-between row">
                              {
                                    sales?.map(({ title, icon, amount, color, border }, i) =>
                                          <div className={`col-lg-3 col-md-6 col-6 px-3 mb-2 ${ border }`} key={i}>
                                                <StyledIcon
                                                      color={color}
                                                >
                                                      {icon}
                                                </StyledIcon>
                                                <div className="d-flex flex-wrap justify-content-between grey-text">
                                                      <p className="small"> {naira}{amount || 0.00} </p>
                                                      <p className="small"> {title}</p>
                                                </div>
                                          </div>
                                    )
                              }
                        </div>
                  </div>
            </StyledSaleOverview>
      );
};

export default SaleOverview;

const StyledSaleOverview = styled.div`
      


`;